/* Sky Meridian GA4. No form values or contact addresses are collected here. */
(() => {
  'use strict';
  const script = document.querySelector('script[data-sky-ga4]');
  const measurementId = script?.dataset.skyGa4;
  if (!/^G-[A-Z0-9]+$/.test(measurementId || '') || window.SkyMeridianAnalytics) return;
  // Keep theme previews and the theme editor out of production analytics.
  if (window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main') return;
  const disableKey = 'ga-disable-' + measurementId;
  let started = false;
  let pageSent = false;
  let featureRequested = false;
  let attempts = 0;
  let privacyReady = false;
  let pendingLead = null;

  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function cleanUrl(value) {
    try { const url = new URL(value); return url.origin + url.pathname; }
    catch (_) { return ''; }
  }
  function tag() { window.dataLayer.push(arguments); }
  function start() {
    if (started || !allowed()) return;
    started = true;
    window.dataLayer = window.dataLayer || [];
    // Retain another integration's gtag function if present.
    window.gtag = window.gtag || tag;
    tag('consent', 'default', {
      analytics_storage: 'denied', ad_storage: 'denied',
      ad_user_data: 'denied', ad_personalization: 'denied'
    });
    tag('consent', 'update', { analytics_storage: 'granted' });
    tag('js', new Date());
    tag('config', measurementId, {
      send_page_view: false,
      allow_google_signals: false,
      allow_ad_personalization_signals: false,
      page_location: cleanUrl(location.href),
      page_referrer: cleanUrl(document.referrer)
    });
    if (!document.querySelector('script[src^="https://www.googletagmanager.com/gtag/js"]')) {
      const loader = document.createElement('script');
      loader.async = true;
      loader.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(measurementId);
      document.head.appendChild(loader);
    }
  }
  function event(name, parameters) {
    if (!allowed()) return;
    window[disableKey] = false;
    start();
    tag('event', name, Object.assign({
      send_to: measurementId,
      page_location: cleanUrl(location.href),
      page_referrer: cleanUrl(document.referrer)
    }, parameters));
  }
  function syncConsent() {
    privacyReady = true;
    const permitted = allowed();
    window[disableKey] = !permitted;
    if (!permitted) {
      pendingLead = null;
      if (started) tag('consent', 'update', { analytics_storage: 'denied' });
      return;
    }
    start();
    tag('consent', 'update', { analytics_storage: 'granted' });
    if (!pageSent) {
      pageSent = true;
      event('page_view', { page_title: document.title });
    }
    if (pendingLead) {
      const parameters = pendingLead;
      pendingLead = null;
      event('generate_lead', parameters);
    }
  }
  window.SkyMeridianAnalytics = Object.freeze({
    allowed,
    lead(mode, service) {
      const parameters = { form_type: mode === 'oferta' ? 'oferta' : 'contact' };
      if (mode === 'oferta' && /^[a-z0-9-]{1,70}$/.test(service || '')) parameters.service = service;
      // A successful Shopify form return can precede asynchronous privacy API loading.
      // The caller already verified consent at submission; recheck it before dispatch.
      if (!privacyReady) { pendingLead = parameters; return; }
      event('generate_lead', parameters);
    }
  });
  document.addEventListener('click', (click) => {
    const anchor = click.target.closest?.('a[href]');
    if (!anchor) return;
    const href = anchor.getAttribute('href') || '';
    if (/^tel:/i.test(href)) event('contact_click', { contact_method: 'phone' });
    else if (/^mailto:/i.test(href)) event('contact_click', { contact_method: 'email' });
  }, { capture: true, passive: true });
  document.addEventListener('visitorConsentCollected', syncConsent);
  function loadPrivacy() {
    if (window.Shopify?.customerPrivacy) { syncConsent(); return; }
    if (window.Shopify?.loadFeatures && !featureRequested) {
      featureRequested = true;
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => {
        if (!error) syncConsent();
        else { privacyReady = true; pendingLead = null; }
      });
      return;
    }
    if (++attempts < 20) setTimeout(loadPrivacy, 250);
  }
  loadPrivacy();
})();
